// this file is automatically generated by git.version.ts script
export const versions = {version: '1.7.0', revision: 'd844726', branch: 'master'};


// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/environments/versions.ts